<template>
  <div id="app">
    <Top />
    <Left />
    <tooltip />
    <router-view />
  </div>
</template>

<script>
import Top from './components/Top'
import Left from './components/Left'

export default {
  name: 'App',
  components: {
    Top,
    Left
  }
}
</script>

<style>
html {
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}
[v-cloak] {
  display: none;
}
/* Scroll */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
::-webkit-scrollbar-thumb:hover {
  background: #9c9c9c;
}
#app {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
h1, h2, h3, h4 {
  font-weight: normal;
}
h5, p {
  text-align: left;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.clearfix {
  margin: 20px 20px 20px 20px;
}
.clearfix--min {
  margin: 10px 10px 10px 10px;
}
.jumbotron {
  position: relative;
  padding-top: 3%;
  padding-bottom: 3%;
}
.border {
  border: 1px solid #000;
}
.left {
  text-align: left !important;
  float: left !important;
  font-size: 90%;
}
.container {
  min-height: 100vh;
  min-width: 100vw;
  margin-left: 0;
  margin-right: 0;
  padding-top: 10vmin !important;
  padding-bottom: 30px !important;
  padding-left: calc(1% + 200px) !important;
  padding-right: 2vmin !important;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  p, button, div {
    font-size: 90% !important;
  }
  details {
    white-space: nowrap;
  }
  table {
    font-size: 98% !important;
  }
  h1 {
    font-size: 1.4em;
  }
  h4 {
    font-size: 1.1em;
  }
  .container {
    margin-top: 7vh !important;
    padding-top: 30px !important;
    padding-bottom: 30px !important;
    padding-right: 10px !important;
    padding-left: 20vw !important;
  }
}
/* module CSS */
.bg--gen-positive {
  background: rgba(65, 184, 81, 0.144) !important;
  background-color: rgba(65, 184, 81, 0.144) !important;
}
.bg--gen-negative {
  background: rgba(87, 181, 228, 0.144) !important;
  background-color: rgba(87, 181, 228, 0.144) !important;
}
.bg--cardio {
  background: rgba(204, 154, 79, 0.144) !important;
  background-color: rgba(204, 154, 79, 0.144) !important;
}
/* ---------- */
.flex-wrapper {
  display: flex;
}
.margin-right-vw {
  margin-right: 4.85vw !important;
}
.margin-left-vw {
  margin-left: 0.85vw !important;
}
.active_left {
  border-left: 6px solid #069ccc;
}
.active_btm {
  border-left: 0;
  border-bottom: 6px solid #069ccc;
}
.cursor-pointer {
  cursor: pointer;
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  select,
  textarea,
  input {
    font-size: 16px;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.input-clear {
  border: 1px solid #ced4da;
  border-top-right-radius: .25rem;
  border-bottom-right-radius: .25rem;
  background: #fff;
  width: 40px;
  height: auto;
}
.input-clear:before {
  content: "\D7";
  width: 1.4em;
  height: 1.4em;
  line-height: 1.1em;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  color: rgba(0,0,0,.3);
}
.filter {
  filter: invert(44%) sepia(0%) saturate(0%) hue-rotate(354deg) brightness(94%) contrast(93%);
}
.div-loader:after {
  content: " ...";
  animation: dots 1.5s steps(5, end) infinite;
}
@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: white;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
  }
}
/* vc-donut ext */
.vc--donut {
  border: 1px solid rgba(0, 0, 0, 0.155);
  border-radius: 50%;
}
/* vue-toggles override */
.vue-toggles {
  display: inline-grid !important;
  vertical-align: text-bottom !important;
}
/* vue-good-table override */
.vgt-left-align {
  font-size: 87% !important;
}
/* bootstrap override */
.jumbotron {
  border: 1px solid rgba(0, 0, 0, 0.123);
}
.alert {
  display: none;
  margin-top: 20px;
}
.alert-bottom-right {
  position: fixed;
  bottom: 0;
  right: 0;
  height: auto;
  width: 250px;
  margin: 20px;
}
.text-primary {
  color: #069ccc !important;
}
.btn-primary {
  background: #069ccc !important;
}
.btn-outline-primary {
  color: #069ccc !important;
  border-color: #069ccc !important;
}
.btn-outline-primary:hover {
  background: #069ccc !important;
  color: #fff !important;
}
.nav-link {
  margin-left: 0 !important;
}
.navbar-toggler-icon {
  display: none;
}
.form-control:disabled, .form-control[readonly] {
  cursor: pointer;
  background-color: #fff !important;
}
/* v-tooltip */
.tooltip {
  display: block !important;
  z-index: 10000;
}
.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}
.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}
.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}
.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue